import * as actionsType from "../actions/actionsType";

const usersReducer = (
  state = {
    allBranches: null,
    usersBranches: null,
  },
  action
) => {
  switch (action.type) {
    case actionsType.GET_ALL_BRANCHES:
      return { ...state, allBranches: action.payload };
    case actionsType.GET_USERS_BRANCHES:
      return { ...state, usersBranches: action.payload };
    default:
      return state;
  }
};

export default usersReducer;
